<template>
  <div>
    <task-summary v-model="maximizeCard" :module_id="8"></task-summary>
    <!-- <vs-button class="block ml-auto" v-if="checkCreatePermission() || checkProjectCreatePermission()" @click="openCreate">Create</vs-button> -->
    <div class="position-relative">
      <vs-button
        class="block ml-auto task_create_btn"
        v-if="checkCreatePermission() || checkProjectCreatePermission()"
        @click="openCreate"
        >Create {{ CreateType }}</vs-button
      >
      <TaskProjectTable
        :taskEditPermission="checkEditPermission()"
        :taskViewPermission="checkViewPermission()"
        :projectViewPermission="checkProjectViewPermission()"
        :checkProjectDeletePermissionData="checkProjectDeletePermission()"
        :checkProjectEditPermissionData="checkProjectEditPermission()"
        :meta_task_data="meta_task"
        :meta_template_data="meta_template"
        :UpdatedListOfLiveTask="ListOfLiveTaskUpdate"
        :UpdatedListOfTask="ListOfTaskUpdate"
        @passEvent="passEvent($event)"
        @passTempEvent="passTempEvent($event)"
        @passEventLive="passEventLive($event)"
        @passEventFilterTask="passEventFilterTask($event)"
        @openModalSection="openModalSection($event)"
        @openModalSectionLive="openModalSectionLive($event)"
        @type1="type1"
        class="mt-4"
      />
    </div>
    <div
      class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
      v-show="openUpdateModal"
      :class="{ show: openUpdateModal }"
    >
      <div class="cstm-modal">
        <div class="header">
          <h4>Edit {{ taskData.is_template ? "Template" : "Task" }}</h4>
          <button @click="closeUpdateModal" class="close-modal">&times;</button>
        </div>
        <div class="each-tabular p-4">
          <div class="cstm-unique-tab-text modal-content">
            <div class="px-2">
              <div class="flex flex-wrap -mx-2">
                <div class="md:w-1/2 w-full px-2 my-2">
                  <vs-input
                    class="w-full"
                    v-model="taskData.name"
                    placeholder="Task Name"
                  />
                </div>
                <div class="md:w-1/2 w-full px-2 my-2">
                  <v-select
                    v-model="taskData.task_priority_id"
                    :reduce="option => option.id"
                    label="level"
                    name="level"
                    :options="priority"
                    placeholder="Choose Priority"
                    style="width: 100%"
                  />
                </div>
                <div
                  class="w-full px-2 my-2"
                  v-if="taskData.is_template !== true"
                >
                  <v-select
                    v-model="taskData.task_status_id"
                    :reduce="option => option.id"
                    label="status"
                    name="status"
                    :options="options"
                    placeholder="Choose Status"
                    style="width: 100%"
                  />
                </div>
                <div class="w-full px-2 my-2">
                  <vs-textarea
                    class="mb-0"
                    v-model="taskData.details"
                    label="Details"
                  />
                </div>
                <div class="md:w-1/2 w-full px-2 my-2">
                  <div class="person-holder">
                    <div>
                      <feather-icon icon="UserIcon" />
                      <span>Responsible Person</span>
                    </div>
                    <div class="cstm-inp flex-wrap">
                      <span
                        class="task-cstm-badge flex items-center mb-2"
                        :key="index4"
                        v-for="(person, index4) in responsibleData"
                      >
                        <img
                          v-if="person.picture != ''"
                          class="
                            person-img
                            rounded-full
                            shadow-md
                            cursor-pointer
                            block
                          "
                          :src="person.picture"
                        />
                        <img
                          v-if="person.picture == ''"
                          class="
                            person-img
                            rounded-full
                            shadow-md
                            cursor-pointer
                            block
                          "
                          src="@/assets/images/pages/user-circle-solid.svg"
                        />
                        {{ person.first_name }} {{ person.last_name }}
                        <feather-icon
                          class="cursor-pointer"
                          icon="XIcon"
                          @click="closeSelected('Responsible', index4)"
                        />
                      </span>
                      <a
                        v-if="responsibleData.length == 0"
                        class="font-bold cursor-pointer"
                        @click="addMoreUser('Responsible')"
                        >+ Add More</a
                      >
                    </div>
                  </div>
                </div>
                <div class="md:w-1/2 w-full px-2 my-2">
                  <span>Deadline</span>

                  <flat-pickr
                    class="cstm-datepicker w-full"
                    placeholder="Select Date"
                    v-model="taskData.due_date"
                    :config="configdateTimePicker1"
                    @input="updateCalendar"
                  />
                </div>
                <vs-divider />
                <vs-tabs v-model="tabIndex" class="inner-tab tooltip_icon_tab">
                  <vs-tab
                    label="Checklist"
                    icon-pack="feather"
                    icon="icon-list"
                  >
                    <span
                      :key="RenderKey"
                      v-if="taskData.checklist.length !== 0"
                    >
                      <span
                        :key="index8"
                        v-for="(item1, index8) in taskData.checklist"
                      >
                        <div class="md:flex flex-nowrap items-center">
                          <div class="flex items-center my-2 whitespace-nowrap">
                            <span class="material-icons">assignment</span>
                            <vs-input
                              style="width:110px;"
                              v-model="item1.name"
                              placeholder="Checklist Name"
                            />
                          </div>
                          <vs-progress
                            :percent="
                              (item1.itemStatusCal.length /
                                item1.todos.length) *
                                100
                            "
                            color="primary"
                          ></vs-progress>
                          <div
                            class="
                              progress-status
                              w-auto
                              text-left
                              md:text-right
                              whitespace-nowrap
                              p-0
                              md:pl-2
                            "
                          >
                            Completed: {{ item1.itemStatusCal.length }} out of
                            {{ item1.todos.length }}
                          </div>
                        </div>
                        <ul class="checklist-ul task-checklist mb-4 m-0">
                          <draggable
                            :list="item1.todos"
                            @change="statusLog"
                            class="w-full p-2"
                            handle=".handle1"
                          >
                            <li
                              class="flex justify-between"
                              :key="index9"
                              v-for="(item2, index9) in item1.todos"
                            >
                              <div class="flex items-center">
                                <span
                                  class="material-icons-outlined simple_drag_icon handle1"
                                  >drag_indicator</span
                                >
                                <vs-checkbox
                                  v-model="item2.is_completed"
                                  @change="changeStatus(index8, index9)"
                                ></vs-checkbox>
                                <span v-html="replaceURLs(item2.todo)"></span>
                              </div>
                              <div class="flex">
                                <vs-button
                                  color="warning"
                                  @click="editItem(index8, index9, item2)"
                                  icon-pack="feather"
                                  icon="icon-edit"
                                  type="flat"
                                ></vs-button>
                                <vs-button
                                  color="danger"
                                  @click="deleteItem(index8, index9)"
                                  icon-pack="feather"
                                  icon="icon-trash-2"
                                  type="flat"
                                ></vs-button>
                              </div>
                            </li>
                          </draggable>
                          <div
                            class="flex justify-between"
                            :key="index2"
                            v-for="(testBox, index2) in item1.showTextBox"
                          >
                            <!-- <vs-input
                          class="inputx w-full mb-4"
                          placeholder="Type and enter to create item3"
                          @keyup.native.enter="submitItemNewTask(index8, item1)"
                          v-model="testBox.itemName"
                        /> -->
                            <input
                              type="text"
                              class="vs-inputx vs-input--input normal mb-4"
                              placeholder="Type and enter to create item"
                              @keyup.enter="submitItemNewTask(index8, item1)"
                              v-model="testBox.itemName"
                            />
                            <vs-button
                              color="danger"
                              icon-pack="feather"
                              icon="icon-trash-2"
                              type="flat"
                              @click="removeItemNewTask(index8, index2)"
                            ></vs-button>
                          </div>
                          <a
                            style="
                            padding-bottom: 2px;
                            border-bottom: 1px solid rgba(var(--vs-primary), 1);
                          "
                            class="cursor-pointer"
                            @click="addItemNewTask(index8)"
                            >+ Item</a
                          >
                        </ul>
                      </span>
                    </span>
                    <div
                      :key="index3"
                      v-for="(checklistRow, index3) in checklistRows"
                    >
                      <div class="md:flex flex-nowrap items-center">
                        <div class="flex items-center my-2 whitespace-nowrap">
                          <span class="material-icons">assignment</span>
                          <vs-input
                            style="width:110px;"
                            v-model="checklistRow.name"
                            placeholder="Checklist Name"
                          />
                        </div>
                        <vs-progress
                          :percent="
                            (checklistRow.itemStatusCal.length /
                              checklistRow.items.length) *
                              100
                          "
                          color="primary"
                        ></vs-progress>
                        <div
                          class="
                            progress-status
                            w-auto
                            text-left
                            md:text-right
                            whitespace-nowrap
                            p-0
                            md:pl-2
                          "
                        >
                          Completed: {{ checklistRow.itemStatusCal.length }} out
                          of {{ checklistRow.items.length }}
                        </div>
                      </div>
                      <ul class="checklist-ul task-checklist mb-4 m-0">
                        <draggable
                          :list="checklistRow.items"
                          @change="statusLog"
                          class="w-full p-2"
                          handle=".handle2"
                        >
                          <li
                            class="flex justify-between"
                            :key="index6"
                            v-for="(item, index6) in checklistRow.items"
                          >
                            <div class="flex items-center">
                              <span
                                class="material-icons-outlined simple_drag_icon handle2"
                                >drag_indicator</span
                              >
                              <vs-checkbox
                                v-model="item.is_completed"
                                @change="changeStatusFromCheck(index3, index6)"
                              ></vs-checkbox>
                              <span v-html="replaceURLs(item.todo)"></span>
                            </div>
                            <div class="flex">
                              <vs-button
                                color="warning"
                                @click="editItemFromCheck(index3, index6, item)"
                                icon-pack="feather"
                                icon="icon-edit"
                                type="flat"
                              ></vs-button>
                              <vs-button
                                color="danger"
                                @click="deleteItemFromCheck(index3, index6)"
                                icon-pack="feather"
                                icon="icon-trash-2"
                                type="flat"
                              ></vs-button>
                            </div>
                          </li>
                        </draggable>
                      </ul>

                      <div
                        class="flex justify-between"
                        :key="index2"
                        v-for="(testBox, index2) in checklistRow.showTextBox"
                      >
                        <vs-input
                          class="inputx w-full mb-4"
                          placeholder="Type and enter to create item"
                          @keyup.native.enter="submitItem(index3, checklistRow)"
                          v-model="testBox.itemName"
                        />
                        <vs-button
                          color="danger"
                          icon-pack="feather"
                          icon="icon-trash-2"
                          type="flat"
                          @click="removeItem(checklistRow, index2)"
                        ></vs-button>
                      </div>
                      <div class="flex flex-wrap justify-between items-center">
                        <a
                          style="
                            padding-bottom: 2px;
                            border-bottom: 1px solid rgba(var(--vs-primary), 1);
                          "
                          class="cursor-pointer"
                          @click="addItem(checklistRow)"
                          >+ Item</a
                        >
                        <a
                          style="color: #ea5455"
                          class="cursor-pointer"
                          @click="removeChecklist(index3)"
                          type="flat"
                          >Remove All</a
                        >
                      </div>
                      <vs-divider />
                    </div>

                    <vs-button class="my-4" @click="addChecklist"
                      >+ Checklist</vs-button
                    >
                  </vs-tab>
                  <vs-tab
                    label="Created By"
                    icon-pack="feather"
                    icon="icon-users"
                  >
                    <div class="my-2">
                      <div class="flex items-center">
                        <feather-icon icon="UserIcon" />
                        <span class="mx-1">Created By</span>
                      </div>
                      <div class="flex flex-wrap -mx-2">
                        <div class="w-full px-2">
                          <vs-input
                            v-if="taskData.created_by.last_name === null"
                            class="w-full"
                            :value="taskData.created_by.first_name"
                            readonly
                          />
                          <vs-input
                            v-else
                            class="w-full"
                            :value="
                              taskData.created_by.first_name +
                                ' ' +
                                taskData.created_by.last_name
                            "
                            readonly
                          />
                        </div>
                      </div>
                    </div>

                    <div class="my-2">
                      <div class="flex items-center">
                        <feather-icon icon="UserIcon" />
                        <span class="mx-1">Participants</span>
                      </div>
                      <div class="flex flex-wrap -mx-2">
                        <div class="cstm-inp flex-wrap">
                          <span
                            class="task-cstm-badge flex items-center"
                            :key="index4"
                            v-for="(person, index4) in participantData"
                          >
                            <img
                              v-if="person.picture != ''"
                              class="
                                person-img
                                rounded-full
                                shadow-md
                                cursor-pointer
                                block
                              "
                              :src="person.picture"
                            />
                            <img
                              v-if="person.picture == ''"
                              class="
                                person-img
                                rounded-full
                                shadow-md
                                cursor-pointer
                                block
                              "
                              src="@/assets/images/pages/user-circle-solid.svg"
                            />
                            {{ person.first_name }} {{ person.last_name }}
                            <feather-icon
                              class="cursor-pointer"
                              icon="XIcon"
                              @click="closeSelected('Participants', index4)"
                            />
                          </span>
                          <a
                            class="font-bold cursor-pointer"
                            @click="addMoreUser('Participants')"
                            >+ Add More</a
                          >
                        </div>
                      </div>
                    </div>

                    <div class="my-2">
                      <div class="flex items-center">
                        <feather-icon icon="UserIcon" />
                        <span class="mx-1">Observers</span>
                      </div>
                      <div class="flex flex-wrap -mx-2">
                        <div class="cstm-inp flex-wrap">
                          <span
                            class="task-cstm-badge flex items-center"
                            :key="index4"
                            v-for="(person, index4) in observerData"
                          >
                            <img
                              v-if="person.picture != ''"
                              class="
                                person-img
                                rounded-full
                                shadow-md
                                cursor-pointer
                                block
                              "
                              :src="person.picture"
                            />
                            <img
                              v-if="person.picture == ''"
                              class="
                                person-img
                                rounded-full
                                shadow-md
                                cursor-pointer
                                block
                              "
                              src="@/assets/images/pages/user-circle-solid.svg"
                            />
                            {{ person.first_name }} {{ person.last_name }}
                            <feather-icon
                              class="cursor-pointer"
                              icon="XIcon"
                              @click="closeSelected('Observers', index4)"
                            />
                          </span>
                          <a
                            class="font-bold cursor-pointer"
                            @click="addMoreUser('Observers')"
                            >+ Add More</a
                          >
                        </div>
                      </div>
                    </div>
                  </vs-tab>

                  <vs-tab
                    label="Time Planning"
                    icon-pack="feather"
                    icon="icon-clock"
                  >
                    <div>
                      <div class="flex items-center my-2">
                        <feather-icon icon="ClockIcon" />
                        <span class="mx-1">Time Planning</span>
                      </div>
                      <div class="flex flex-wrap items-center">
                        <div class="md:w-1/2 w-full md:pr-2">
                          <label class="w-full">From</label>
                          <div class="fake_flatpickr_holder">
                            <div class="fake_input_holder">
                              <span v-if="taskData.from_time != ''">{{
                                $moment(taskData.from_time).format(
                                  "D MMMM, YYYY h:mm A"
                                )
                              }}</span>
                              <span v-else>-</span>
                            </div>
                            <flat-pickr
                              :config="configdateTimePicker"
                              v-model="taskData.from_time"
                              @on-close="checkWhenClose('from')"
                            />
                          </div>
                        </div>
                        <div class="md:w-1/2 w-full md:pl-2">
                          <label class="w-full">To</label>
                          <div class="fake_flatpickr_holder">
                            <div class="fake_input_holder">
                              <span v-if="taskData.to_time != ''"
                                >{{
                                  $moment(taskData.to_time).format(
                                    "D MMMM, YYYY h:mm A"
                                  )
                                }}
                              </span>
                              <span v-else>-</span>
                            </div>
                            <flat-pickr
                              :config="configdateTimePicker"
                              v-model="taskData.to_time"
                              @on-close="checkWhenClose('to')"
                              :disabled="taskData.from_time == ''"
                            />
                          </div>
                        </div>
                      </div>
                      <vs-divider />
                      <div v-if="taskData.is_tracking_active">
                        <div
                          v-if="participantData.find(u => u.id == userInfo.id)"
                        >
                          <div class="flex items-center my-2">
                            <feather-icon icon="ClockIcon" />
                            <span class="mx-1">Log</span>
                          </div>
                          <div
                            class="flex flex-wrap items-center"
                            :key="index10"
                            v-for="(log, index10) in logs"
                          >
                            <vs-input
                              class="width-10"
                              v-model="log.no_of_days"
                              type="number"
                            />
                            <span class="mx-2">Days</span>
                            <vs-input
                              class="width-10"
                              v-model="log.no_of_hours"
                              type="number"
                            />
                            <span class="mx-2">Hour</span>
                          </div>
                          <br />
                          <vs-button @click="addLog">+ Log</vs-button>&nbsp;
                          <vs-button
                            color="success"
                            @click="submitLog(live_update_id)"
                            >Save</vs-button
                          >

                          <div>
                            <div class="flex items-center my-2">
                              <feather-icon icon="ClockIcon" />
                              <span class="mx-1">Log History</span>
                            </div>
                            <div
                              class="task-cstm-badge flex items-center"
                              :key="index10"
                              v-for="(log, index10) in logHistory"
                            >
                              {{ log.no_of_days }}
                              <span class="mx-2">Days</span>
                              {{ log.no_of_hours }}
                              <span class="mx-2">Hour</span>
                            </div>
                            <br />
                          </div>
                        </div>
                      </div>
                    </div>
                  </vs-tab>

                  <vs-tab label="Project" icon-pack="feather" icon="icon-grid">
                    <div>
                      <div class="flex flex-wrap items-center">
                        <label class="md:w-1/5 w-full">Projects</label>
                        <div class="md:w-3/4 w-full">
                          <v-select
                            v-model="taskData.project"
                            class="w-full"
                            :reduce="option => option.id"
                            label="name"
                            name="name"
                            :options="projectList"
                            placeholder="Project"
                            @open="onOpenProject"
                            @close="onCloseProject"
                          >
                            <template #list-footer>
                              <li
                                ref="loadProject"
                                class="loader"
                                v-show="projectListMeta.has_next"
                              >
                                Loading more project...
                              </li>
                            </template>
                          </v-select>
                        </div>
                      </div>
                      <vs-divider />

                      <div class="flex flex-wrap">
                        <div class="md:w-1/5 w-full">
                          <label>Remind about task</label>
                        </div>
                        <div class="md:w-3/4 w-full">
                          <div
                            class="inline-flex items-center m-1 w-full"
                            :key="index"
                            v-for="(item, index) in reminderTime"
                          >
                            <flat-pickr
                              class="w-full"
                              :config="configdateTimePicker1"
                              v-model="item.reminder_time"
                              placeholder="Choose Date & Time"
                            />
                            <vs-button
                              class="cursor-pointer font-semibold ml-1"
                              @click="removeReminder(index)"
                              icon-pack="feather"
                              icon="icon-minus"
                              color="danger"
                            ></vs-button>
                          </div>
                          <a
                            class="cursor-pointer font-semibold inline-block"
                            @click="addReminder"
                            >+ Reminder</a
                          >
                        </div>
                      </div>
                      <vs-divider />
                      <!-- <div class="flex flex-wrap items-center">
                                                <label class="w-1/5">Gantt</label>
                                                <a class="cursor-pointer font-semibold">+ Add Previous Task</a>
                                            </div>
                                            <vs-divider /> -->

                      <div class="flex flex-wrap items-center">
                        <label class="md:w-1/5 w-full">CRM</label>
                        <div class="cstm-inp md:w-3/4 w-full">
                          <span
                            class="task-cstm-badge flex items-center"
                            :key="index8"
                            v-for="(crm, index8) in selectedCRMData"
                          >
                            {{ crm.lead_first_name }}
                            <feather-icon
                              class="cursor-pointer"
                              icon="XIcon"
                              @click="closeSelected('CRM', index8)"
                            />
                          </span>
                          <a
                            class="font-bold cursor-pointer"
                            @click="addModal('CRM')"
                            >+ Add More</a
                          >
                        </div>
                      </div>
                      <vs-divider />

                      <div class="flex flex-wrap items-center">
                        <label class="md:w-1/5 w-full">SubTask</label>
                        <div class="cstm-inp md:w-3/4 w-full">
                          <span
                            class="task-cstm-badge flex items-center"
                            :key="index8"
                            v-for="(task, index8) in selectedSubTaskData"
                          >
                            {{ task.name }}
                            <feather-icon
                              class="cursor-pointer"
                              icon="XIcon"
                              @click="closeSelected('subTask', index8)"
                            />
                          </span>
                          <a
                            class="font-bold cursor-pointer"
                            @click="addModal('subTask')"
                            >+ Add</a
                          >
                        </div>
                      </div>
                      <vs-divider />

                      <div class="flex flex-wrap items-center">
                        <label class="md:w-1/5 w-full">Tags</label>
                        <div style="margin: 0 5px" class="md:w-3/4 w-full">
                          <v-select
                            append-to-body
                            class="w-full"
                            label="name"
                            taggable
                            :reduce="option => option.id"
                            :create-option="
                              option => ({
                                id: option,
                                label: option,
                                name: option
                              })
                            "
                            :options="tagsList"
                            v-model="taskData.tags"
                            :clearable="false"
                            data-vv-name="name"
                            name="name"
                            multiple
                            placeholder="Type and Enter"
                          >
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </vs-tab>

                  <vs-tab label="Editor" icon-pack="feather" icon="icon-type">
                    <editor
                      :api-key="tinyMceApi"
                      v-model="taskData.comments"
                      :init="initializeTinyMce"
                    />
                  </vs-tab>
                </vs-tabs>
                <vs-divider />
                <div class="md:w-1/2 w-full px-2 my-2">
                  <vs-checkbox v-model="taskData.is_template" vs-value="1"
                    >Save this as a template</vs-checkbox
                  >
                </div>
              </div>
            </div>
            <div class="my-2 text-right">
              <vs-button
                class="mx-2"
                v-if="!live_update_id && update_id"
                :disabled="!buttonActive"
                @click="updateTaskDataTemplate"
                >Update</vs-button
              >
              <vs-button
                class="mx-2"
                v-else
                :disabled="!buttonActive"
                @click="updateTaskDataLive"
                >Update</vs-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <vs-popup
      classContent="popup-example"
      class="editChecklistPopup"
      title="Edit Item"
      :active.sync="checklistEditPopup"
    >
      <vs-input
        placeholder="Type and enter to create item"
        v-model="editChecklistName"
        @keyup.native.enter="updateItemForCheck()"
        class="mt-5 w-full"
      />
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      class="editChecklistPopup"
      title="Edit Item"
      :active.sync="checklistEditPopup2"
    >
      <vs-input
        placeholder="Type and enter to create item"
        v-model="editChecklistName"
        @keyup.native.enter="updateItem()"
        class="mt-5 w-full"
      />
    </vs-popup>
    <vs-popup
      class="holamundo userModalStyle"
      :title="typeOfPersonTitle"
      :active.sync="popupresponse"
    >
      <vs-tabs class="cstm_line_tabular_view">
        <vs-tab label="Staff">
          <div class="tab-text">
            <vs-input
              v-if="query_page_user.page == 1"
              class="ml-auto mb-4"
              icon-pack="feather"
              icon="icon-search"
              icon-before
              placeholder="Search"
              type="text"
              @input="fetchUserBySearch"
              v-model="searchName"
              >Search</vs-input
            >
            <div class="person-list-holder">
              <vs-table v-model="selectedUsers" :data="userList">
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].picture">
                      <img
                        v-if="data[indextr].picture != ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        :src="data[indextr].picture"
                      />
                      <img
                        v-if="data[indextr].picture == ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].first_name">
                      {{ data[indextr].first_name }}
                      {{ data[indextr].last_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>

              <!-- <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="currentPageUser > 1"
                    @click="showBackUser"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-chevron-right"
                    v-if="showButtonUser == true"
                    @click="showMoreUser"
                  ></vs-button>
                </div>
              </div> -->
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Student">
          <div class="tab-text">
            <vs-input
              v-if="query_page_client.page == 1"
              class="ml-auto mb-4"
              icon-pack="feather"
              icon="icon-search"
              icon-before
              placeholder="Search"
              type="text"
              @input="fetchClientBySearch"
              v-model="searchName"
              >Search</vs-input
            >
            <div class="person-list-holder">
              <vs-table v-model="selectedClients" :data="clientList">
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].picture">
                      <img
                        v-if="data[indextr].picture != ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        :src="data[indextr].picture"
                      />
                      <img
                        v-if="data[indextr].picture == ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].first_name">
                      {{ data[indextr].first_name }}
                      {{ data[indextr].last_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <!-- <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="currentPageClient > 1"
                    @click="showBackClient"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-chevron-right"
                    v-if="showButtonClient == true"
                    @click="showMoreClient"
                  ></vs-button>
                </div>
              </div> -->
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right" @click="addUser">Add</vs-button>
    </vs-popup>
    <vs-popup
      class="holamundo userModalStyle"
      :title="typeOfPersonTitle"
      :active.sync="popupActive"
    >
      <vs-tabs class="cstm_line_tabular_view">
        <vs-tab label="Staff">
          <div class="tab-text">
            <vs-input
              v-if="query_page_user.page == 1"
              class="ml-auto mb-4"
              icon-pack="feather"
              icon="icon-search"
              icon-before
              placeholder="Search"
              type="text"
              @input="fetchUserBySearch"
              v-model="searchName"
              >Search</vs-input
            >
            <div class="person-list-holder">
              <vs-table multiple v-model="selectedUsers" :data="userList">
                <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].picture">
                      <img
                        v-if="data[indextr].picture != ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        :src="data[indextr].picture"
                      />
                      <img
                        v-if="data[indextr].picture == ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].first_name">
                      {{ data[indextr].first_name }}
                      {{ data[indextr].last_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>

              <!-- <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="currentPageUser > 1"
                    @click="showBackUser"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-chevron-right"
                    v-if="showButtonUser == true"
                    @click="showMoreUser"
                  ></vs-button>
                </div>
              </div> -->
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Student">
          <div class="tab-text">
            <vs-input
              v-if="query_page_client.page == 1"
              class="ml-auto mb-4"
              icon-pack="feather"
              icon="icon-search"
              icon-before
              placeholder="Search"
              type="text"
              @input="fetchClientBySearch"
              v-model="searchName"
              >Search</vs-input
            >
            <div class="person-list-holder">
              <vs-table multiple v-model="selectedClients" :data="clientList">
                <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].picture">
                      <img
                        v-if="data[indextr].picture != ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        :src="data[indextr].picture"
                      />
                      <img
                        v-if="data[indextr].picture == ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].first_name">
                      {{ data[indextr].first_name }}
                      {{ data[indextr].last_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <!-- <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="currentPageClient > 1"
                    @click="showBackClient"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-chevron-right"
                    v-if="showButtonClient == true"
                    @click="showMoreClient"
                  ></vs-button>
                </div>
              </div> -->
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right" @click="addUser">Add</vs-button>
    </vs-popup>
    <vs-popup
      class="holamundo userModalStyle"
      title="Add Project"
      :active.sync="popupActiveProj"
    >
      <vs-tabs>
        <vs-tab label="Project">
          <div class="tab-text">
            <div class="person-list-holder">
              <vs-table
                multiple
                v-model="selectedProjects"
                :data="ListOfProject"
              >
                <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].name">
                      {{ data[indextr].name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <vs-row vs-type="flex" vs-justify="space-between">
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="flex-end"
                  vs-w="11.5"
                >
                  <vs-button
                    v-if="meta.has_next"
                    @click="showProj('plus')"
                    icon-pack="feather"
                    icon="icon-plus"
                    style="float: right"
                    >More</vs-button
                  >
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="flex-end"
                  vs-w=".5"
                >
                  <vs-button
                    type="flat"
                    v-if="meta.current_page > 1"
                    @click="showProj('minus')"
                    icon-pack="feather"
                    icon="icon-arrow-left"
                  ></vs-button>
                </vs-col>
              </vs-row>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right" @click="addMicData('project')"
        >Add</vs-button
      >
    </vs-popup>
    <vs-popup
      class="holamundo userModalStyle"
      title="Add CRM"
      :active.sync="popupActiveCRM"
    >
      <vs-tabs>
        <vs-tab label="CRM">
          <div class="tab-text">
            <div class="person-list-holder">
              <vs-table multiple v-model="selectedCRM" :data="leadList">
                <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].lead_first_name">
                      {{ data[indextr].lead_first_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <vs-row vs-type="flex" vs-justify="space-between">
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="flex-end"
                  vs-w="11.5"
                >
                  <vs-button
                    v-if="leadMeta.has_next"
                    @click="showCRM('plus')"
                    icon-pack="feather"
                    icon="icon-plus"
                    style="float: right"
                    >More</vs-button
                  >
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="flex-end"
                  vs-w=".5"
                >
                  <vs-button
                    type="flat"
                    v-if="leadMeta.current_page > 1"
                    @click="showCRM('minus')"
                    icon-pack="feather"
                    icon="icon-arrow-left"
                  ></vs-button>
                </vs-col>
              </vs-row>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right" @click="addMicData('CRM')">Add</vs-button>
    </vs-popup>
    <vs-popup
      class="holamundo userModalStyle"
      title="Add Sub Task"
      :active.sync="popupActiveSubTask"
    >
      <vs-tabs>
        <vs-tab label="Sub Task">
          <div class="tab-text">
            <div class="person-list-holder">
              <vs-table
                multiple
                v-model="selectedSubTask"
                :data="parentTaskData"
              >
                <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].name">
                      {{ data[indextr].name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <vs-row vs-type="flex" vs-justify="space-between">
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="flex-end"
                  vs-w="11.5"
                >
                  <vs-button
                    v-if="sub_meta.has_next"
                    @click="showSubTask('plus')"
                    icon-pack="feather"
                    icon="icon-plus"
                    style="float: right"
                    >More</vs-button
                  >
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="flex-end"
                  vs-w=".5"
                >
                  <vs-button
                    type="flat"
                    v-if="sub_meta.current_page > 1"
                    @click="showSubTask('minus')"
                    icon-pack="feather"
                    icon="icon-arrow-left"
                  ></vs-button>
                </vs-col>
              </vs-row>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right" @click="addMicData('subTask')"
        >Add</vs-button
      >
    </vs-popup>
    <div v-if="isBrowseContent">
      <vs-popup
        fullscreen
        title="Browse Item"
        :active.sync="isBrowseContent"
        class="childImportPopUp browse_modal_item"
      >
        <import-browse-files-model
          v-if="isBrowseContent"
          :file_repository_id="repository_id"
          @getImportFile="getImportFile"
          :multipleSelect="true"
        ></import-browse-files-model>
        <div slot="footer"></div>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { TaskProject } from './mixins/task-project.js'
import TaskProjectTable from './components/task-project-table.vue'
import { taskTemplateShow } from '@/api/task-project.js'
import { Project } from './mixins/project.js'
import TaskSummary from '../analytics/summeryTaskList'
import { GoogleAuthorization } from '@/mixins/common/GoogleAuthorization.js'
import ImportBrowseFilesModel from '@/components/common/ImportBrowseFilesModel.vue'
import { repository } from '@/mixins/repository.js'
export default {
  mixins: [
    TaskProject,
    Project,
    PermissionMiddleware,
    GoogleAuthorization,
    repository
  ],
  components: {
    TaskProjectTable,
    TaskSummary,
    ImportBrowseFilesModel,
    vSelect
  },
  data () {
    return {
      CreateType: 'Tasks',
      tabIndex: 0,
      maximizeCard: true,
      cstmconfigdateTimePicker: {
        disable: []
      }
    }
  },
  computed: {
    buttonActive () {
      if (
        this.responsibleData.length !== 0 &&
        this.taskData.name !== '' &&
        this.taskData.task_priority_id !== ''
      ) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    tabIndex () {
      this.initializePopupMutationObserver()
    },
    userList () {
      const obj = {
        userList: this.userList,
        showButtonUser: this.showButtonUser,
        currentPageUser: this.query_page_user.page
      }
      this.$store.commit('UPDATE_USER_LIST', obj)
    },
    clientList () {
      const obj = {
        clientList: this.clientList,
        showButtonClient: this.showButtonClient,
        currentPageClient: this.query_page_client.page
      }
      this.$store.commit('UPDATE_CLIENT_LIST', obj)
    },
    priority () {
      const obj = {
        priority: this.priority
      }
      this.$store.commit('UPDATE_PRIORITY_LIST', obj)
    },
    tagsList () {
      const obj = {
        tagsList: this.tagsList,
        tag_meta: this.tag_meta
      }
      this.$store.commit('UPDATE_TAG_LIST', obj)
    },
    parentTaskData () {
      const obj = {
        parentTaskData: this.parentTaskData,
        sub_meta: this.sub_meta
      }
      this.$store.commit('UPDATE_PARENT_LIST', obj)
    },
    ListOfTaskUpdate () {
      const obj = {
        ListOfTaskUpdate: this.ListOfTaskUpdate,
        meta_template: this.meta_template
      }
      this.$store.commit('UPDATE_TEMPLATE_LIST', obj)
    },
    ListOfLiveTaskUpdate () {
      const obj = {
        ListOfLiveTaskUpdate: this.ListOfLiveTaskUpdate,
        meta_task: this.meta_task
      }
      this.$store.commit('UPDATE_LIVE_LIST', obj)
    },
    leadList () {
      const obj = {
        leadList: this.leadList,
        leadMeta: this.leadMeta
      }
      this.$store.commit('UPDATE_LEAD_LIST', obj)
    },
    ListOfProject () {
      const obj = {
        ListOfProject: this.ListOfProject,
        meta: this.meta
      }
      this.$store.commit('UPDATE_PROJECT_LIST', obj)
    },
    file_repository_id () {
      const obj = {
        fetchRepoId: this.repository_id
      }
      this.$store.commit('UPDATE_REPO_ID', obj)
    }
  },
  async mounted () {
    await this.getRepositoryId(this.TASK_MODULE_ID)
    this.file_repository_id = this.repository_id
    this.priorityList()
    this.fetchLeadList()
    this.fetchUser()
    this.fetchClient()
    this.listOfTag(this.tag_meta.current_page)
    this.parentTask(this.sub_meta.current_page)
    this.fetchProject(this.meta)
    this.fetchTaskUpdate(this.query_page_data)
    this.fetchLiveTaskUpdate(this.query_page_data)
  },
  methods: {
    type1 (data) {
      this.CreateType = data
      console.log(data)
    },
    openModalSection (data) {
      console.log(data)
      this.update_id = data.id ? data.id : data.data.id
      taskTemplateShow(localStorage.getItem('customer_id'), this.update_id)
        .then(res => {
          const task = res.data.data.task
          this.taskData.name = task.name
          this.taskData.due_date = task.due_date
          this.changedDataForFlatpicker.dueDate = task.due_date
          this.taskData.created_by = task.created_by
          this.taskData.task_priority_id = task.task_priority.id
          this.taskData.comments = task.comments
          this.taskData.details = task.details
          this.taskData.clientResponsiblePerson = task.clientResponsiblePerson
          this.taskData.userResponsiblePerson = task.userResponsiblePerson
          this.taskData.is_template = true
          this.responsibleData = task.userResponsiblePerson.concat(
            task.clientResponsiblePerson
          )
        })
        .catch(e => {
          console.log(e)
        })
      this.openUpdateModal = true
    },

    closeUpdateModal () {
      this.clearData()
      this.openUpdateModal = false
    },
    passEvent (data) {
      this.fetchTaskUpdate(data)
    },
    passEventLive (data) {
      this.fetchLiveTaskUpdate(data)
    },
    passEventFilterTask (data) {
      console.log(data)
      const queryPayloadString = Object.assign({}, this.$route.query)
      queryPayloadString.page = data.page
      queryPayloadString.limit = data.limit
      queryPayloadString.attribute = data.attribute
      queryPayloadString.field_type = data.field_type
      queryPayloadString.direction = data.direction
      delete data.limit
      delete data.direction
      delete data.field_type
      delete data.attribute
      this.fetchLiveTaskUpdate(queryPayloadString, data)
    },
    passTempEvent (data) {
      console.log(data)
      const queryPayloadString = Object.assign({}, this.$route.query)
      queryPayloadString.page = data.page
      queryPayloadString.limit = data.limit
      queryPayloadString.attribute = data.attribute
      queryPayloadString.field_type = data.field_type
      queryPayloadString.direction = data.direction
      delete data.limit
      delete data.direction
      delete data.field_type
      delete data.attribute
      this.fetchTaskUpdate(queryPayloadString, data)
    },
    openCreate () {
      const QueryParams = {
        projectId: 0,
        project: false,
        CreateType: this.CreateType
      }
      this.$router
        .push({
          name: 'tasks-project-create',
          params: { payload: QueryParams }
        })
        .catch(() => {})
    }
  }
}
</script>
<style>
.userModalStyle {
  z-index: 100000;
}
.editChecklistPopup {
  z-index: 53002;
}
</style>
